import script from "./PopupReaderConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupReaderConfirm.vue?vue&type=script&setup=true&lang=js"

import "./PopupReaderConfirm.vue?vue&type=style&index=0&id=0b8aee9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8aee9c"]])

export default __exports__